import React, { useState, useEffect } from "react";

import Header from "../components/header";
import DividerBottom from "../components/divider-bottom";
import Footer from "../components/footer";

import TShirt from "../assets/images/tshirt.jpg";
import Scarf from "../assets/images/17th.png";
import Woggles from "../assets/images/woggles.jpg";

const PRODUCT_ACCESS_CODE = "17thuniforms";

function Replacements() {
  const [accessCode, setAccessCode] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [error, setError] = useState("");

  const [basket, setBasket] = useState([]);
  const [total, setTotal] = useState(0);

  const [shirtSize, setShirtSize] = useState("7-8");
  const [scarfSize, setScarfSize] = useState("Child");
  const [woggleColour, setWoggleColour] = useState("Red");

  useEffect(() => {
    if (sessionStorage.getItem("loggedIn") === "true") {
      setLoggedIn(true);
    }
  }, []);

  const checkLogin = () => {
    if (accessCode === PRODUCT_ACCESS_CODE) {
      sessionStorage.setItem("loggedIn", "true");
      setLoggedIn(true);
      setError("");
    } else {
      setError("Incorrect access code.");
    }
  };

  const addItem = (name, option, price) => {
    const item = `${name} (${option}) - £${price}`;
    setBasket([...basket, item]);
    setTotal(total + price);
  };

  const removeItem = (index) => {
    const itemPrice = parseInt(basket[index].split("£")[1]);
    setTotal(total - itemPrice);
    setBasket(basket.filter((_, i) => i !== index));
  };

  const confirmOrder = () => {
    if (basket.length === 0) {
      alert("Your basket is empty.");
      return;
    }

    document.getElementById("order-details").value = basket.join("\n");
    document.getElementById("order-total").value = "£" + total;
  };

  return (
    <>
      <Header />
        <main>
        <section id="products">
            <h1>Replacement Uniform Items</h1>

            {!loggedIn && (
            <div id="product-login">
                <p>Please enter the access code to continue.</p>

                <input
                type="password"
                placeholder="Access Code"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
                />

                <button onClick={checkLogin}>Log-in</button>

                <p style={{ color: "red" }}>{error}</p>
            </div>
            )}

            {loggedIn && (
            <div id="product-system">
                <div className="products-container">

                {/* T-SHIRT */}
                <div className="product-card">
                    <img src={TShirt} alt="T-Shirt" />
                    <h3>T-Shirt</h3>
                    <p>£6</p>

                    <select onChange={(e) => setShirtSize(e.target.value)}>
                    <option value="7-8">7-8</option>
                    <option value="9-11">9-11</option>
                    <option value="12-13">12-13</option>
                    <option value="Small">Small</option>
                    <option value="Medium">Medium</option>
                    <option value="Large">Large</option>
                    </select>

                    <button onClick={() => addItem("T-Shirt", shirtSize, 6)}>
                    Add to Basket
                    </button>
                </div>

                {/* SCARF */}
                <div className="product-card">
                    <img src={Scarf} alt="Scarf" />
                    <h3>Scarf</h3>
                    <p>£5</p>

                    <select onChange={(e) => setScarfSize(e.target.value)}>
                    <option value="Child">Child</option>
                    <option value="Adult">Adult</option>
                    </select>

                    <button onClick={() => addItem("Scarf", scarfSize, 5)}>
                    Add to Basket
                    </button>
                </div>

                {/* WOGGLE */}
                <div className="product-card">
                    <img src={Woggles} alt="Woggle" />
                    <h3>Woggle</h3>
                    <p>£1</p>

                    <select onChange={(e) => setWoggleColour(e.target.value)}>
                    <option value="Red">Red</option>
                    <option value="Orange">Orange</option>
                    <option value="Yellow">Yellow</option>
                    <option value="Blue">Blue</option>
                    <option value="Purple">Purple</option>
                    <option value="Scout">Scout</option>
                    </select>

                    <button onClick={() => addItem("Woggle", woggleColour, 1)}>
                    Add to Basket
                    </button>
                </div>
                </div>

                {/* BASKET */}
                <div id="basket-container">
                <h2>Your Basket</h2>

                {basket.map((item, i) => (
                    <div id="basket-item" key={i}>
                      <p>{item}</p>
                      <button onClick={() => removeItem(i)}>
                        ×
                      </button>
                    </div>
                ))}

                <hr />
                <h3>Total: £{total}</h3>
                <h4>By confirming this order, you agree to pay the total amount due to the 17th Bournemouth Scout Group.</h4>
                <h4>Payment should be made, in cash, at the time of collection.</h4>
                <hr />
                <form
                    id="order-form"
                    action="https://formspree.io/f/mreajepk"
                    method="POST"
                >
                    <label><strong>Name & Section:</strong></label>

                    <input
                    type="text"
                    name="Name & Section"
                    id="order-subject"
                    placeholder="E.g. John Doe - Cubs"
                    required
                    />

                    <input type="hidden" name="Item(s)" id="order-details" />
                    <input type="hidden" name="Order Total" id="order-total" />

                    <button id="submit" type="submit" onClick={confirmOrder}>
                    Confirm Order
                    </button>
                </form>
                </div>
            </div>
            )}
        </section>
        <DividerBottom />
        </main>
        <Footer />
     </>
  );
}

export default Replacements;